import './browsercheck';
import './modules/languageSelect';
import '../supportTicket/supportWindow';
import './modules/appEvents';
import './modules/popupFunctions';
import '../general/modules/utilityFunctions';
import {initCookieWarning} from './modules/cookieWarning';
import 'modules/downloadPopup';
import consoleLogger from '../logger/consoleLogger';
import { GameClient } from '../gameClient/gameClient';
import { PayFinishCommand } from '../gameClient/clientCommands/payFinishCommand';
import { LayoutFixes } from '../layout/layoutFixes';
import { PaymentStatus } from '../constants/paymentStatus';
import { reenableFullscreenIfWasEnabled } from '../gameClient/webgl/fullscreenFixer';
import { Environment } from '../environment/environment';
import './modules/pollWindow';
import { CurrentEntryPoint } from '../constants/CurrentEntryPoint';
import { container } from '../utils/container/container';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { ServiceIds } from '../utils/container/service-ids';
import { FlagNames } from '../utils/feature-flags/flag-names';

const logger = consoleLogger.getPrefixedCopy('GAME_GENERAL');

window.app.payFinish = onPayFinish;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function onPayFinish(status: number, _pmId?: number, errorFBMessage: any = false) {
    let cmd;

    reenableFullscreenIfWasEnabled();
    logger.info('pay', 'Finish', status);

    // @ts-ignore
    status = parseInt(status, 10);
    if (status === PaymentStatus.SUCCESS || status === PaymentStatus.INITIATED) {
        window.app.setPayerFlag();
    }

    cmd = new PayFinishCommand({
        status: status,
        last_payment: window.app.last_payment,
        fbError: errorFBMessage
    });

    GameClient.getInstance().sendCommand<void>(cmd);
    window.app.last_payment = void 0;
}


const tabActivityTracker = {
    handleVisibilityChange() {
        try {
            console.log('HandleVisibilityChange');
            if (document.hidden) {
                window.app.tabActivity.lastActiveTime = Date.now();
                console.log(`go to inactive ${window.app.tabActivity.lastActiveTime} ms`);
            } else {
                console.log(`lastAсtiveTime ${window.app.tabActivity.lastActiveTime} ms`);
                window.app.tabActivity.totalTimeInactive += Date.now() - window.app.tabActivity.lastActiveTime;
                console.log(`total time in another tab ${window.app.tabActivity.totalTimeInactive} ms`);
            }
        } catch (err) {
            console.log(err);
        }
    },
    initBackgroundTimer() {
        try {
            window.app.tabActivity = {
                lastActiveTime: Date.now(),
                totalTimeInactive: 0
            };
            $(document).on('visibilitychange', tabActivityTracker.handleVisibilityChange);
        } catch (err) {
            console.log(err);
        }
    }
};

window.app.initGroupLinks = function() {
    $('.js-group_link').on('click', function() {
        const link = `${$(this).data('link')}`;

        if (typeof link !== 'undefined' && link.trim() !== '') {
            window.open(link);
        }
    });
};

export function initGameGeneral() {
    window.app.initGroupLinks();

    if (!Environment.isSocial() && CurrentEntryPoint.SITE === window.app.config.current_entry_point) {
        initCookieWarning();
    }

    // TODO TMP FIX, remove onready handler from root level, export and use in game page handler
    if (!$(document.body).hasClass('article')) {
        LayoutFixes.setupLayoutFixes();
    }

    const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
    const isDevMode = ffLoader.get(FlagNames.ENABLE_SITE_DEV_TOOLS).isOn();

    if (isDevMode) {
        import('../devUtils/devSettingsPanel').then(({ DevSettingsPanel }) => {
            const devSettingsPanel = $('.dev-settings-panel');
            if (DevSettingsPanel && (devSettingsPanel.length && devSettingsPanel.is(':visible'))) {
                DevSettingsPanel.init();
            }
        });
    }
}
